var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AbpHttpInterceptor } from 'abp-ng2-module/src/abpHttpInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
var ServiceProxyModule = /** @class */ (function () {
    function ServiceProxyModule() {
    }
    ServiceProxyModule = __decorate([
        NgModule({
            providers: [
                ApiServiceProxies.AuditLogServiceProxy,
                ApiServiceProxies.CachingServiceProxy,
                ApiServiceProxies.ChatServiceProxy,
                ApiServiceProxies.CommonLookupServiceProxy,
                ApiServiceProxies.EditionServiceProxy,
                ApiServiceProxies.FriendshipServiceProxy,
                ApiServiceProxies.HostSettingsServiceProxy,
                ApiServiceProxies.InstallServiceProxy,
                { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
                ApiServiceProxies.LanguageServiceProxy,
                ApiServiceProxies.NotificationServiceProxy,
                ApiServiceProxies.BackgroundJobServiceProxy,
                ApiServiceProxies.OrganizationUnitServiceProxy,
                ApiServiceProxies.PermissionServiceProxy,
                ApiServiceProxies.ProfileServiceProxy,
                ApiServiceProxies.RoleServiceProxy,
                ApiServiceProxies.SessionServiceProxy,
                ApiServiceProxies.TenantServiceProxy,
                ApiServiceProxies.TenantDashboardServiceProxy,
                ApiServiceProxies.TenantSettingsServiceProxy,
                ApiServiceProxies.TimingServiceProxy,
                ApiServiceProxies.UserServiceProxy,
                ApiServiceProxies.UserLinkServiceProxy,
                ApiServiceProxies.UserLoginServiceProxy,
                ApiServiceProxies.WebLogServiceProxy,
                ApiServiceProxies.AccountServiceProxy,
                ApiServiceProxies.TokenAuthServiceProxy,
                ApiServiceProxies.TenantRegistrationServiceProxy,
                ApiServiceProxies.HostDashboardServiceProxy,
                ApiServiceProxies.PaymentServiceProxy,
                ApiServiceProxies.DemoUiComponentsServiceProxy,
                ApiServiceProxies.DeviceModelServiceProxy,
                ApiServiceProxies.DeviceServiceProxy,
                ApiServiceProxies.ConfigureServiceProxy,
                ApiServiceProxies.VariableServiceProxy,
                ApiServiceProxies.FBoxVariableServiceProxy,
                ApiServiceProxies.AlarmRegistrationsServiceProxy,
                ApiServiceProxies.OperationCenterServiceProxy,
                ApiServiceProxies.FBoxAccountSettingsServiceProxy,
                ApiServiceProxies.FBoxServiceProxy,
                ApiServiceProxies.DeviceMonitorServiceProxy,
                ApiServiceProxies.GalleryServiceProxy,
                ApiServiceProxies.HistoryDataServiceProxy,
                ApiServiceProxies.FBoxHistoryDataServiceProxy,
                ApiServiceProxies.ConfigureGalleryServiceProxy,
                ApiServiceProxies.ReleasedConfigureServiceProxy,
                ApiServiceProxies.ReleasedConfigureGraphServiceProxy,
                ApiServiceProxies.SystemGalleryServiceProxy,
                ApiServiceProxies.UserGalleryAppSerivceServiceProxy,
                ApiServiceProxies.InvoiceServiceProxy,
                ApiServiceProxies.SubscriptionServiceProxy,
                ApiServiceProxies.RepairManageServiceProxy,
                ApiServiceProxies.RepairListServiceProxy,
                ApiServiceProxies.WorkOrderServiceProxy,
                ApiServiceProxies.WorkOrderListServiceProxy,
                ApiServiceProxies.RepairProgressServiceProxy,
                ApiServiceProxies.WorkOrderProgressServiceProxy,
                ApiServiceProxies.EzvizServiceProxy,
                ApiServiceProxies.FaultTypeServiceProxy,
                ApiServiceProxies.UiCustomizationSettingsServiceProxy,
                ApiServiceProxies.FBoxServiceProxy,
                ApiServiceProxies.MaintenancePlanServiceProxy,
                ApiServiceProxies.MaintenancePlanListServiceProxy,
                ApiServiceProxies.FBoxServiceProxy,
                ApiServiceProxies.DeviceCameraServiceProxy,
                ApiServiceProxies.ThumbnailAssginDeviceServiceProxy,
                ApiServiceProxies.ThumbnailGroupServiceProxy,
                ApiServiceProxies.DeviceMaintenancePlanServiceProxy,
                ApiServiceProxies.ThumbnailServiceProxy,
                ApiServiceProxies.DeviceMaintenancePlanServiceProxy,
                ApiServiceProxies.MaintenanceRecordsServiceProxy,
                ApiServiceProxies.DocumentManageServiceProxy,
                ApiServiceProxies.DocumentSpaceServiceProxy,
                ApiServiceProxies.ConfigurePermissionServiceProxy,
                ApiServiceProxies.DevicePermissionServiceProxy,
                ApiServiceProxies.ConfigureViewServiceProxy,
                ApiServiceProxies.ConfigureSettingsServiceProxy,
                ApiServiceProxies.DataSourceServiceProxy,
                ApiServiceProxies.DataSourceImportInfoServiceProxy,
                ApiServiceProxies.ReleasedDataSourceAppSerivceServiceProxy,
                ApiServiceProxies.VirtualDeviceDataSourceServiceProxy,
                ApiServiceProxies.DataSourceImportInfoServiceProxy,
                ApiServiceProxies.VirtualDeviceOperationHistoriesServiceProxy,
                ApiServiceProxies.DeviceMonitorTreeServiceProxy,
                ApiServiceProxies.DeviceListServiceProxy,
                ApiServiceProxies.ConfigureReleaseServiceProxy,
                ApiServiceProxies.DevicePositionServiceProxy,
                ApiServiceProxies.VirtualDeviceStateServiceProxy,
                ApiServiceProxies.VirtualDeviceAlarmServiceProxy,
                ApiServiceProxies.VirtualDeviceHistoryDataServiceProxy,
                ApiServiceProxies.VirtualDeviceDataSourceBindServiceProxy,
                ApiServiceProxies.VirtualDeviceForceIssueServiceProxy,
                ApiServiceProxies.DeviceGroupServiceProxy,
                ApiServiceProxies.CustomManualNotificationServiceProxy,
                ApiServiceProxies.DeviceGroupServiceProxy,
                ApiServiceProxies.ReportsServiceProxy,
                ApiServiceProxies.ReportTableSchemaServiceProxy,
                ApiServiceProxies.ReportResultServiceProxy,
                ApiServiceProxies.ReportSearchCriteriaServiceProxy,
                ApiServiceProxies.DashboardServiceProxy,
                ApiServiceProxies.ReportApplyServiceProxy,
                ApiServiceProxies.VirtualDeviceServiceProxy,
                ApiServiceProxies.DeviceDetailServiceProxy,
                ApiServiceProxies.ReportsPreviewTableServiceProxy,
                ApiServiceProxies.DeviceReportSearchServiceProxy,
                ApiServiceProxies.ConfigureVideoServiceProxy,
                ApiServiceProxies.VirtualDeviceVideoServiceProxy,
                ApiServiceProxies.FBoxAlarmRegistrationServiceProxy,
                ApiServiceProxies.DataSourceServiceProxy,
                ApiServiceProxies.FBoxMicroScriptServiceProxy,
                ApiServiceProxies.DeviceInfoServiceProxy,
                ApiServiceProxies.VirtualDeviceWeatherServiceProxy,
                ApiServiceProxies.DeviceRepairBomServiceProxy,
                ApiServiceProxies.FileHelperServiceProxy,
                ApiServiceProxies.VirtualDeviceWeatherServiceProxy,
                ApiServiceProxies.DeviceDocumentServiceProxy,
                ApiServiceProxies.DeviceDashboardServiceProxy,
                ApiServiceProxies.VariableGroupServiceProxy,
                ApiServiceProxies.AlarmGroupServiceProxy,
                ApiServiceProxies.DeviceCustomFieldServiceProxy,
                ApiServiceProxies.AlarmGroupServiceProxy,
                ApiServiceProxies.ConfigureEventGroupServiceProxy,
                ApiServiceProxies.ConfigureEventServiceProxy,
                ApiServiceProxies.BaiduTokenServiceProxy,
                ApiServiceProxies.WorkAttendanceServiceServiceProxy,
                ApiServiceProxies.WorkAttendanceRuleServiceProxy,
                ApiServiceProxies.BatchControlServiceProxy,
                ApiServiceProxies.OperationCenterConfigServiceProxy,
                ApiServiceProxies.DeviceLogServiceProxy,
                ApiServiceProxies.SerialNumberServiceProxy,
                ApiServiceProxies.DataDictionaryServiceProxy,
                ApiServiceProxies.InternalOrganizationServiceProxy,
                ApiServiceProxies.ExternalOrganizationServiceProxy,
                ApiServiceProxies.OrganizationServiceProxy,
                ApiServiceProxies.LoginInfoServiceProxy,
                ApiServiceProxies.CustomTitleServiceProxy,
                ApiServiceProxies.HistoryAlarmServiceProxy,
                ApiServiceProxies.HistoryEventServiceProxy,
                ApiServiceProxies.ReleasedVariableServiceProxy,
                ApiServiceProxies.LiveReportServiceProxy,
                ApiServiceProxies.WeChatServiceProxy,
                ApiServiceProxies.OrganizationDataPermissionServiceProxy,
                ApiServiceProxies.ModelGroupServiceProxy,
                ApiServiceProxies.ModelShareServiceProxy,
                ApiServiceProxies.ModelImportServiceProxy,
                ApiServiceProxies.ConfigureDashboardServiceProxy,
                ApiServiceProxies.LiveVariableDataServiceProxy,
                ApiServiceProxies.ResetPasswordServiceProxy,
                ApiServiceProxies.TenantRegisterServiceProxy,
                ApiServiceProxies.TableUserFilterServiceProxy,
                ApiServiceProxies.TableDataFavoriteServiceProxy,
                ApiServiceProxies.RegionServiceProxy,
            ]
        })
    ], ServiceProxyModule);
    return ServiceProxyModule;
}());
export { ServiceProxyModule };
